export default __webpack_public_path__ + "static/media/credit.b360c158.svg";